import {
  Injectable,
  makeStateKey,
  StateKey,
  TransferState,
  inject,
} from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { UserContext } from '../models/user-context';
import { isServerContext, Nillable, once } from '@web/utils';

@Injectable({
  providedIn: 'root',
})
export class UserContextStorage {
  private readonly transferState = inject(TransferState);

  private readonly isServerContext = isServerContext();
  private readonly stateKey = this.makeStateKey();
  private readonly userContextSource$ = this.createUserContextSource();

  public clear(): void {
    this.userContextSource$.next(null);
  }

  public fetchSync(): Nillable<UserContext> {
    return this.userContextSource$.getValue();
  }

  public fetch(): Observable<Nillable<UserContext>> {
    if (this.isServerContext) {
      const context = this.transferState.get(this.stateKey, null);

      return of(context);
    }

    return this.userContextSource$.asObservable().pipe(once());
  }

  public store(context: UserContext): void {
    this.tryToSetTransferState(context);

    this.userContextSource$.next(context);
  }

  private tryToSetTransferState(context: UserContext): void {
    if (this.isServerContext) {
      this.transferState.set(this.stateKey, context);
    }
  }

  private makeStateKey(): StateKey<Nillable<UserContext>> {
    return makeStateKey<Nillable<UserContext>>(
      '90efd39e-b706-4077-9e7c-b70e3fc2860d',
    );
  }

  private createUserContextSource(): BehaviorSubject<Nillable<UserContext>> {
    return new BehaviorSubject<Nillable<UserContext>>(null);
  }
}
